import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Button as Button$1, TextField as TextField$1, Card as Card$1, CardHeader, CardContent, Chip, Tooltip, Popover, Box, Typography, CardMedia, Stack, IconButton, Divider, LinearProgress, Skeleton, Container, Grid, Table, TableHead, TableRow, TableCell, TableBody, InputAdornment, FormControl, InputLabel, Select, MenuItem, FormHelperText, Paper, List, ListItem, ListItemText, ListItemSecondaryAction, Breadcrumbs, Link, Snackbar, Alert } from '@mui/material';
import { Warning, HourglassEmpty, VerifiedUser, Favorite, FavoriteBorder, LocationOn, Bed, Bathtub, SquareFoot, Shield, CloudUpload, InsertDriveFile, Delete, Error as Error$1, CheckCircle, NavigateNext, ArrowBack, Inbox, Search, Add, ErrorOutline, FolderOpen } from '@mui/icons-material';
import React, { useState, useCallback, createContext, useContext, useMemo, useEffect, useRef } from 'react';
import { Controller } from 'react-hook-form';
import { styled, createTheme } from '@mui/material/styles';
import axios from 'axios';

/**
 * Boma Trust Brand Configuration
 *
 * SINGLE SOURCE OF TRUTH for all brand-related constants.
 * Import this file whenever you need to display the brand name,
 * tagline, URLs, or other brand assets.
 *
 * To rebrand: Update ONLY this file, then rebuild.
 */
var BRAND = {
    /** Official brand name - use this in all UI */
    name: 'Boma Trust',
    /** Short name for compact spaces */
    shortName: 'Boma',
    /** Legal entity name */
    legalName: 'Boma Trust Ltd',
    /** Tagline for marketing */
    tagline: 'Invest in Kenyan Real Estate with Confidence',
    /** Short description for SEO */
    description: 'The trusted platform for diaspora investors to discover, verify, and invest in Kenyan real estate.',
    /** Domain (without protocol) */
    domain: 'bomatrust.com',
    /** Full website URL */
    url: 'https://bomatrust.com',
    /** Support email */
    supportEmail: 'support@bomatrust.com',
    /** Social media handles */
    social: {
        twitter: '@bomatrust',
        facebook: 'bomatrust',
        linkedin: 'boma-trust',
        instagram: 'bomatrust',
    },
    /** Copyright text */
    copyright: function (year) {
        if (year === void 0) { year = new Date().getFullYear(); }
        return "\u00A9 ".concat(year, " Boma Trust. All rights reserved.");
    },
    /** SEO defaults */
    seo: {
        titleTemplate: '%s | Boma Trust',
        defaultTitle: 'Boma Trust - Invest in Kenyan Real Estate with Confidence',
        ogSiteName: 'Boma Trust',
    },
};

var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return _assign.apply(this, arguments);
};
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
}
function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

/**
 * Primary UI component for user interaction
 */
var Button = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return jsx(Button$1, _assign({}, props, { children: children }));
};
Button.defaultProps = {
    variant: 'contained',
    color: 'primary',
    size: 'medium',
};

/**
 * Standard Input component for Boma Trust forms.
 * Wraps MUI TextField with project-specific defaults.
 */
var Input = function (props) {
    return jsx(TextField$1, _assign({ variant: "outlined", fullWidth: true, margin: "normal" }, props));
};
Input.defaultProps = {
    variant: 'outlined',
    fullWidth: true,
    margin: 'normal',
};

/**
 * Standard Card container.
 */
var Card = function (_a) {
    var title = _a.title, subheader = _a.subheader, children = _a.children, _b = _a.noPadding, noPadding = _b === void 0 ? false : _b, sx = _a.sx, props = __rest(_a, ["title", "subheader", "children", "noPadding", "sx"]);
    return (jsxs(Card$1, _assign({ elevation: 1, sx: _assign({ borderRadius: 2, overflow: 'hidden' }, sx) }, props, { children: [(title || subheader) && (jsx(CardHeader, { title: title, subheader: subheader, titleTypographyProps: { variant: 'h6', fontWeight: 600 } })), jsx(CardContent, { sx: { p: noPadding ? 0 : 2, '&:last-child': { pb: noPadding ? 0 : 2 } }, children: children })] })));
};

/**
 * VerificationBadge - Displays property verification status with visual indicators
 */
var VerificationBadge = function (_a) {
    var _b = _a.status, status = _b === void 0 ? 'unverified' : _b, _c = _a.size, size = _c === void 0 ? 'small' : _c, _d = _a.showTooltip, showTooltip = _d === void 0 ? true : _d, details = _a.details, _e = _a.interactive, interactive = _e === void 0 ? false : _e, sx = _a.sx, props = __rest(_a, ["status", "size", "showTooltip", "details", "interactive", "sx"]);
    var getConfig = function () {
        switch (status) {
            case 'verified':
                return {
                    label: 'VERIFIED',
                    icon: jsx(VerifiedUser, { sx: { fontSize: size === 'small' ? 16 : 20 } }),
                    color: 'success',
                    tooltip: 'This property has been verified by Boma Trust',
                    bgColor: 'success.main',
                    textColor: 'white',
                };
            case 'pending':
                return {
                    label: 'PENDING',
                    icon: jsx(HourglassEmpty, { sx: { fontSize: size === 'small' ? 16 : 20 } }),
                    color: 'warning',
                    tooltip: 'Verification in progress',
                    bgColor: 'warning.main',
                    textColor: 'white',
                };
            case 'unverified':
            default:
                return {
                    label: 'UNVERIFIED',
                    icon: jsx(Warning, { sx: { fontSize: size === 'small' ? 16 : 20 } }),
                    color: 'default', // Changed from error to default/grey as per KAN-43
                    tooltip: 'This property has not been verified',
                    bgColor: 'grey.400',
                    textColor: 'white',
                };
        }
    };
    var config = getConfig();
    var _f = React.useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var open = Boolean(anchorEl);
    var popoverId = open ? 'verification-badge-popover' : undefined;
    var effectiveDetails = details && details.length > 0
        ? details
        : status === 'verified'
            ? ['Title deed checked', 'Land registry verified', 'Encumbrance search cleared']
            : status === 'pending'
                ? ['Verification in progress', 'Documents under review']
                : ['Not verified yet'];
    var badge = (jsx(Chip, _assign({ label: config.label, icon: config.icon, size: size, color: config.color, clickable: interactive, onClick: interactive
            ? function (e) {
                setAnchorEl(e.currentTarget);
            }
            : props.onClick, "aria-describedby": interactive ? popoverId : undefined, sx: _assign(_assign({ fontWeight: 'bold', letterSpacing: 0.5, height: size === 'small' ? 24 : 32, bgcolor: config.bgColor, color: config.textColor, '& .MuiChip-icon': {
                color: 'inherit',
            } }, (interactive
            ? {
                cursor: 'pointer',
                '&:focus-visible': {
                    outline: '2px solid',
                    outlineOffset: 2,
                    outlineColor: 'secondary.main',
                },
            }
            : {})), sx), "data-testid": "verification-badge" }, props)));
    var wrappedBadge = showTooltip ? (jsx(Tooltip, { title: config.tooltip, arrow: true, children: jsx("span", { children: badge }) })) : (badge);
    if (!interactive) {
        return wrappedBadge;
    }
    return (jsxs(Fragment, { children: [wrappedBadge, jsx(Popover, { id: popoverId, open: open, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, children: jsxs(Box, { sx: { p: 2, maxWidth: 280 }, children: [jsx(Typography, { variant: "subtitle2", fontWeight: 700, gutterBottom: true, children: "What\u2019s verified" }), jsx(Box, { component: "ul", sx: { pl: 2, m: 0 }, children: effectiveDetails.map(function (d) { return (jsx(Box, { component: "li", sx: { mb: 0.5 }, children: jsx(Typography, { variant: "body2", color: "text.secondary", children: d }) }, d)); }) })] }) })] }));
};

/**
 * Boma Trust Formatting Utilities
 *
 * Common formatting functions for currency, dates, numbers, and more.
 */
/**
 * Currency symbol constants - SINGLE SOURCE OF TRUTH
 * Use these constants throughout the application for consistency
 */
var CURRENCY_SYMBOLS = {
    KES: 'Ksh',
    USD: '$',
    GBP: '£',
    EUR: '€',
};
/**
 * Format a number as Kenyan Shillings (Ksh)
 *
 * @param amount - The amount to format
 * @param options - Formatting options
 * @returns Formatted currency string
 *
 * @example
 * formatCurrency(1500000) // "Ksh 1,500,000"
 * formatCurrency(1500000, { showDecimals: true }) // "Ksh 1,500,000.00"
 */
function formatCurrency(amount, options) {
    if (options === void 0) { options = {}; }
    var _a = options.currency, currency = _a === void 0 ? 'KES' : _a, _b = options.showDecimals, showDecimals = _b === void 0 ? false : _b, _c = options.compact, compact = _c === void 0 ? false : _c;
    var symbol = CURRENCY_SYMBOLS[currency] || CURRENCY_SYMBOLS.KES;
    if (compact) {
        return formatCompactNumber(amount, "".concat(symbol, " "));
    }
    var formatted = amount.toLocaleString('en-KE', {
        minimumFractionDigits: showDecimals ? 2 : 0,
        maximumFractionDigits: showDecimals ? 2 : 0,
    });
    return "".concat(symbol, " ").concat(formatted);
}
/**
 * Format a number in compact notation (e.g., 1.5M, 500K)
 *
 * @param amount - The amount to format
 * @param prefix - Currency prefix
 * @returns Compact formatted string
 *
 * @example
 * formatCompactNumber(1500000) // "1.5M"
 * formatCompactNumber(1500000, 'KES') // "KES 1.5M"
 */
function formatCompactNumber(amount, prefix) {
    if (prefix === void 0) { prefix = ''; }
    var absAmount = Math.abs(amount);
    var sign = amount < 0 ? '-' : '';
    if (absAmount >= 1000000000) {
        return "".concat(sign).concat(prefix).concat((absAmount / 1000000000).toFixed(1), "B");
    }
    if (absAmount >= 1000000) {
        return "".concat(sign).concat(prefix).concat((absAmount / 1000000).toFixed(1), "M");
    }
    if (absAmount >= 1000) {
        return "".concat(sign).concat(prefix).concat((absAmount / 1000).toFixed(1), "K");
    }
    return "".concat(sign).concat(prefix).concat(absAmount);
}
/**
 * Format a date string or Date object
 *
 * @param date - Date to format
 * @param format - Format style
 * @returns Formatted date string
 *
 * @example
 * formatDate('2024-01-15') // "Jan 15, 2024"
 * formatDate('2024-01-15', 'long') // "January 15, 2024"
 * formatDate('2024-01-15', 'relative') // "2 months ago"
 */
function formatDate(date, format) {
    if (format === void 0) { format = 'medium'; }
    var dateObj = typeof date === 'string' ? new Date(date) : date;
    if (isNaN(dateObj.getTime())) {
        return 'Invalid date';
    }
    if (format === 'relative') {
        return formatRelativeTime(dateObj);
    }
    var optionsMap = {
        short: { month: 'short', day: 'numeric' },
        medium: { month: 'short', day: 'numeric', year: 'numeric' },
        long: { month: 'long', day: 'numeric', year: 'numeric' },
    };
    var options = optionsMap[format];
    return dateObj.toLocaleDateString('en-US', options);
}
/**
 * Format a date as relative time (e.g., "2 hours ago")
 *
 * @param date - Date to format
 * @returns Relative time string
 */
function formatRelativeTime(date) {
    var now = new Date();
    var diffMs = now.getTime() - date.getTime();
    var diffSec = Math.floor(diffMs / 1000);
    var diffMin = Math.floor(diffSec / 60);
    var diffHour = Math.floor(diffMin / 60);
    var diffDay = Math.floor(diffHour / 24);
    var diffWeek = Math.floor(diffDay / 7);
    var diffMonth = Math.floor(diffDay / 30);
    var diffYear = Math.floor(diffDay / 365);
    if (diffSec < 60)
        return 'just now';
    if (diffMin < 60)
        return "".concat(diffMin, " minute").concat(diffMin > 1 ? 's' : '', " ago");
    if (diffHour < 24)
        return "".concat(diffHour, " hour").concat(diffHour > 1 ? 's' : '', " ago");
    if (diffDay < 7)
        return "".concat(diffDay, " day").concat(diffDay > 1 ? 's' : '', " ago");
    if (diffWeek < 4)
        return "".concat(diffWeek, " week").concat(diffWeek > 1 ? 's' : '', " ago");
    if (diffMonth < 12)
        return "".concat(diffMonth, " month").concat(diffMonth > 1 ? 's' : '', " ago");
    return "".concat(diffYear, " year").concat(diffYear > 1 ? 's' : '', " ago");
}
/**
 * Format a file size in bytes to human-readable format
 *
 * @param bytes - Size in bytes
 * @returns Formatted size string
 *
 * @example
 * formatFileSize(1024) // "1 KB"
 * formatFileSize(1048576) // "1 MB"
 */
function formatFileSize$1(bytes) {
    if (bytes < 1024)
        return "".concat(bytes, " B");
    if (bytes < 1024 * 1024)
        return "".concat((bytes / 1024).toFixed(1), " KB");
    if (bytes < 1024 * 1024 * 1024)
        return "".concat((bytes / (1024 * 1024)).toFixed(1), " MB");
    return "".concat((bytes / (1024 * 1024 * 1024)).toFixed(1), " GB");
}
/**
 * Format a Kenyan phone number
 *
 * @param phone - Phone number to format
 * @returns Formatted phone number
 *
 * @example
 * formatPhoneNumber('0712345678') // "+254 712 345 678"
 * formatPhoneNumber('254712345678') // "+254 712 345 678"
 */
function formatPhoneNumber(phone) {
    // Remove all non-digits
    var digits = phone.replace(/\D/g, '');
    // Handle Kenyan numbers
    var normalized = digits;
    if (digits.startsWith('254')) {
        normalized = digits.slice(3);
    }
    else if (digits.startsWith('0')) {
        normalized = digits.slice(1);
    }
    // Format as +254 XXX XXX XXX
    if (normalized.length === 9) {
        return "+254 ".concat(normalized.slice(0, 3), " ").concat(normalized.slice(3, 6), " ").concat(normalized.slice(6));
    }
    // Return original if can't format
    return phone;
}
/**
 * Format a number with thousand separators
 *
 * @param num - Number to format
 * @param decimals - Number of decimal places
 * @returns Formatted number string
 *
 * @example
 * formatNumber(1234567) // "1,234,567"
 * formatNumber(1234.567, 2) // "1,234.57"
 */
function formatNumber(num, decimals) {
    if (decimals === void 0) { decimals = 0; }
    return num.toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    });
}
/**
 * Format a percentage
 *
 * @param value - Value to format (0-100 or 0-1)
 * @param options - Formatting options
 * @returns Formatted percentage string
 *
 * @example
 * formatPercentage(75) // "75%"
 * formatPercentage(0.75, { isDecimal: true }) // "75%"
 */
function formatPercentage(value, options) {
    if (options === void 0) { options = {}; }
    var _a = options.isDecimal, isDecimal = _a === void 0 ? false : _a, _b = options.decimals, decimals = _b === void 0 ? 0 : _b;
    var percentage = isDecimal ? value * 100 : value;
    return "".concat(percentage.toFixed(decimals), "%");
}
/**
 * Truncate text with ellipsis
 *
 * @param text - Text to truncate
 * @param maxLength - Maximum length
 * @returns Truncated text
 *
 * @example
 * truncateText('This is a long text', 10) // "This is a..."
 */
function truncateText(text, maxLength) {
    if (text.length <= maxLength)
        return text;
    return "".concat(text.slice(0, maxLength).trim(), "...");
}
/**
 * Format a name (capitalize first letter of each word)
 *
 * @param name - Name to format
 * @returns Formatted name
 *
 * @example
 * formatName('john doe') // "John Doe"
 */
function formatName(name) {
    return name
        .toLowerCase()
        .split(' ')
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
        .join(' ');
}

/**
 * PropertyCard - Displays a property listing card with image, details, and actions
 */
var PropertyCard = function (_a) {
    var property = _a.property, onViewDetails = _a.onViewDetails, onToggleFavorite = _a.onToggleFavorite, _b = _a.showFavoriteButton, showFavoriteButton = _b === void 0 ? true : _b;
    var handleViewDetails = function () {
        if (onViewDetails) {
            onViewDetails(property);
        }
    };
    var handleToggleFavorite = function (e) {
        e.stopPropagation();
        if (onToggleFavorite) {
            onToggleFavorite(property);
        }
    };
    var formatPrice = function (price) {
        return formatCurrency(price);
    };
    return (jsxs(Card, { noPadding: true, sx: { height: '100%', display: 'flex', flexDirection: 'column' }, children: [jsxs(Box, { sx: { position: 'relative' }, children: [jsx(CardMedia, { component: "img", height: "200", image: property.imageUrl || 'https://via.placeholder.com/400x200?text=No+Image', alt: property.title, sx: { cursor: onViewDetails ? 'pointer' : 'default' }, onClick: onViewDetails ? handleViewDetails : undefined }), jsx(Box, { sx: { position: 'absolute', top: 10, left: 10 }, children: jsx(VerificationBadge, { status: property.verificationStatus }) }), property.yieldRate && (jsx(Box, { sx: { position: 'absolute', top: 10, right: 10 }, children: jsx(Chip, { label: "Yield: ".concat(property.yieldRate), color: "secondary", size: "small", sx: { fontWeight: 700 } }) }))] }), jsxs(CardContent, { sx: { flexGrow: 1, display: 'flex', flexDirection: 'column', gap: 2 }, children: [jsxs(Box, { children: [jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "flex-start", children: [jsx(Typography, { variant: "h6", component: "div", sx: {
                                            fontWeight: 600,
                                            lineHeight: 1.2,
                                            mb: 1,
                                            cursor: onViewDetails ? 'pointer' : 'default',
                                            '&:hover': onViewDetails
                                                ? { color: 'primary.main', textDecoration: 'underline' }
                                                : {},
                                        }, onClick: onViewDetails ? handleViewDetails : undefined, children: property.title }), showFavoriteButton && (jsx(IconButton, { onClick: handleToggleFavorite, size: "small", "data-testid": "favorite-button", color: property.isFavorite ? 'error' : 'default', children: property.isFavorite ? jsx(Favorite, {}) : jsx(FavoriteBorder, {}) }))] }), jsxs(Stack, { direction: "row", alignItems: "center", spacing: 0.5, sx: { color: 'text.secondary', mb: 1 }, children: [jsx(LocationOn, { fontSize: "small" }), jsx(Typography, { variant: "body2", children: property.location })] }), jsx(Typography, { variant: "h5", color: "primary", fontWeight: 700, children: formatPrice(property.price) })] }), jsx(Divider, {}), jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [jsxs(Stack, { direction: "row", spacing: 0.5, alignItems: "center", title: "".concat(property.specs.beds, " Bedrooms"), children: [jsx(Bed, { fontSize: "small", color: "action" }), jsxs(Typography, { variant: "body2", fontWeight: 500, children: [property.specs.beds, " Beds"] })] }), jsxs(Stack, { direction: "row", spacing: 0.5, alignItems: "center", title: "".concat(property.specs.baths, " Bathrooms"), children: [jsx(Bathtub, { fontSize: "small", color: "action" }), jsxs(Typography, { variant: "body2", fontWeight: 500, children: [property.specs.baths, " Baths"] })] }), jsxs(Stack, { direction: "row", spacing: 0.5, alignItems: "center", title: "".concat(property.specs.sqft, " Square Feet"), children: [jsx(SquareFoot, { fontSize: "small", color: "action" }), jsxs(Typography, { variant: "body2", fontWeight: 500, children: [property.specs.sqft, " sqft"] })] })] }), jsx(Button$1, { variant: "outlined", fullWidth: true, onClick: handleViewDetails, sx: { mt: 'auto' }, children: "View Details & Verification" })] })] }));
};

var TrustScoreDisplay = function (_a) {
    var score = _a.score, _b = _a.variant, variant = _b === void 0 ? 'badge' : _b, _c = _a.breakdown, breakdown = _c === void 0 ? null : _c, _d = _a.showBreakdown, showBreakdown = _d === void 0 ? true : _d;
    var getScoreConfig = function (score) {
        if (score >= 90)
            return { label: 'Excellent', color: '#1B9C6E', bgColor: '#E8F5E9' };
        if (score >= 75)
            return { label: 'Good', color: '#4CAF50', bgColor: '#E8F5E9' };
        if (score >= 60)
            return { label: 'Fair', color: '#FFC107', bgColor: '#FFF8E1' };
        if (score >= 40)
            return { label: 'Caution', color: '#FF9800', bgColor: '#FFF3E0' };
        return { label: 'High Risk', color: '#F44336', bgColor: '#FFEBEE' };
    };
    var _e = getScoreConfig(score), label = _e.label, color = _e.color, bgColor = _e.bgColor;
    var renderBreakdownTooltip = function () {
        if (!breakdown || !showBreakdown)
            return null;
        return (jsxs(Box, { sx: { p: 1, minWidth: 200 }, children: [jsx(Typography, { variant: "subtitle2", sx: { mb: 1, fontWeight: 'bold' }, children: "Score Breakdown" }), Object.entries(breakdown).map(function (_a) {
                    var category = _a[0], value = _a[1];
                    return (jsxs(Box, { sx: { mb: 0.5 }, children: [jsxs(Box, { sx: { display: 'flex', justifyContent: 'space-between', mb: 0.25 }, children: [jsx(Typography, { variant: "caption", children: category }), jsxs(Typography, { variant: "caption", fontWeight: "bold", children: [value, "%"] })] }), jsx(LinearProgress, { variant: "determinate", value: value, sx: { height: 4, borderRadius: 2 } })] }, category));
                })] }));
    };
    if (variant === 'badge') {
        var badge = (jsx(Chip, { icon: jsx(Shield, { sx: { color: "".concat(color, " !important"), fontSize: 18 } }), label: "".concat(score, "/100"), size: "small", sx: {
                bgcolor: bgColor,
                color: color,
                fontWeight: 'bold',
                border: "1px solid ".concat(color),
            }, "data-testid": "trust-score-badge" }));
        if (showBreakdown && breakdown) {
            return (jsx(Tooltip, { title: renderBreakdownTooltip(), arrow: true, children: badge }));
        }
        return badge;
    }
    if (variant === 'detailed') {
        return (jsxs(Box, { sx: {
                p: 2,
                borderRadius: 2,
                bgcolor: bgColor,
                border: "1px solid ".concat(color),
            }, "data-testid": "trust-score-detailed", children: [jsxs(Box, { sx: { display: 'flex', alignItems: 'center', mb: 1 }, children: [jsx(Shield, { sx: { color: color, mr: 1 } }), jsxs(Typography, { variant: "h6", sx: { color: color, fontWeight: 'bold' }, children: ["Boma Trust Score: ", score, "/100"] })] }), jsx(Typography, { variant: "body2", sx: { color: color, mb: 1 }, children: label }), jsx(LinearProgress, { variant: "determinate", value: score, sx: {
                        height: 8,
                        borderRadius: 4,
                        bgcolor: 'rgba(0,0,0,0.1)',
                        '& .MuiLinearProgress-bar': { bgcolor: color },
                    } }), breakdown && showBreakdown && (jsx(Box, { sx: { mt: 2 }, children: Object.entries(breakdown).map(function (_a) {
                        var category = _a[0], value = _a[1];
                        return (jsxs(Box, { sx: { mb: 1 }, children: [jsxs(Box, { sx: { display: 'flex', justifyContent: 'space-between' }, children: [jsx(Typography, { variant: "caption", children: category }), jsxs(Typography, { variant: "caption", fontWeight: "bold", children: [value, "%"] })] }), jsx(LinearProgress, { variant: "determinate", value: value, sx: { height: 4, borderRadius: 2 } })] }, category));
                    }) }))] }));
    }
    // Compact variant
    return (jsxs(Box, { sx: { display: 'flex', alignItems: 'center' }, "data-testid": "trust-score-compact", children: [jsx(Shield, { sx: { color: color, fontSize: 16, mr: 0.5 } }), jsx(Typography, { variant: "body2", sx: { color: color, fontWeight: 'bold' }, children: score })] }));
};

var PriceDisplay = function (_a) {
    var amount = _a.amount, _b = _a.currency, currency = _b === void 0 ? 'KES' : _b, _c = _a.showConversion, showConversion = _c === void 0 ? true : _c, _d = _a.exchangeRate, exchangeRate = _d === void 0 ? 130 : _d, _e = _a.variant, variant = _e === void 0 ? 'h6' : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, _g = _a.color, color = _g === void 0 ? 'primary.main' : _g;
    var formatPrice = function (value, currencyCode) {
        return formatCurrency(value, { currency: currencyCode });
    };
    var sizeConfig = {
        small: { main: 'body1', secondary: 'caption' },
        medium: { main: 'h6', secondary: 'caption' },
        large: { main: 'h4', secondary: 'body2' },
    };
    var _h = sizeConfig[size] || sizeConfig.medium, main = _h.main, secondary = _h.secondary;
    var mainVariant = variant || main;
    var usdAmount = Math.round(amount / exchangeRate);
    return (jsxs(Box, { "data-testid": "price-display", children: [jsx(Typography, { variant: mainVariant, color: color, fontWeight: "bold", "data-testid": "price-main", children: formatPrice(amount, currency) }), showConversion && currency === 'KES' && (jsxs(Typography, { variant: secondary, color: "text.secondary", "data-testid": "price-conversion", children: ["~", formatPrice(usdAmount, 'USD'), " USD"] }))] }));
};

/**
 * PropertyCardSkeleton - Loading placeholder for PropertyCard
 */
var PropertyCardSkeleton = function (_a) {
    var _b = _a.count, count = _b === void 0 ? 1 : _b;
    var renderSkeleton = function (key) { return (jsxs(Card$1, { sx: {
            borderRadius: 3,
            boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        }, "data-testid": "property-card-skeleton", children: [jsx(Skeleton, { variant: "rectangular", height: 220, sx: { borderTopLeftRadius: 12, borderTopRightRadius: 12 } }), jsxs(CardContent, { children: [jsxs(Stack, { direction: "row", justifyContent: "space-between", sx: { mb: 1 }, children: [jsxs(Box, { sx: { flex: 1, mr: 2 }, children: [jsx(Skeleton, { variant: "text", width: "80%", height: 28 }), jsx(Skeleton, { variant: "text", width: "60%", height: 20 })] }), jsxs(Box, { sx: { textAlign: 'right' }, children: [jsx(Skeleton, { variant: "text", width: 100, height: 28 }), jsx(Skeleton, { variant: "text", width: 70, height: 16 })] })] }), jsx(Skeleton, { variant: "rectangular", height: 48, sx: { borderRadius: 2, mb: 2 } }), jsx(Skeleton, { variant: "rectangular", height: 40, sx: { borderRadius: 1 } })] })] }, key)); };
    if (count === 1) {
        return renderSkeleton(0);
    }
    return jsx(Fragment, { children: Array.from({ length: count }, function (_, i) { return renderSkeleton(i); }) });
};

/**
 * ListSkeleton - Generic list loading placeholder
 */
var ListSkeleton = function (_a) {
    var _b = _a.rows, rows = _b === void 0 ? 5 : _b, _c = _a.showAvatar, showAvatar = _c === void 0 ? false : _c, _d = _a.showAction, showAction = _d === void 0 ? false : _d;
    return (jsx(Stack, { spacing: 2, "data-testid": "list-skeleton", children: Array.from({ length: rows }, function (_, i) { return (jsxs(Box, { sx: {
                display: 'flex',
                alignItems: 'center',
                p: 2,
                bgcolor: 'background.paper',
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'divider',
            }, children: [showAvatar && jsx(Skeleton, { variant: "circular", width: 40, height: 40, sx: { mr: 2 } }), jsxs(Box, { sx: { flex: 1 }, children: [jsx(Skeleton, { variant: "text", width: "60%", height: 24 }), jsx(Skeleton, { variant: "text", width: "40%", height: 18 })] }), showAction && (jsx(Skeleton, { variant: "rectangular", width: 80, height: 32, sx: { borderRadius: 1 } }))] }, i)); }) }));
};

/**
 * PageSkeleton - Full page loading placeholder
 */
var PageSkeleton = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'default' : _b;
    if (variant === 'detail') {
        return (jsxs(Container, { maxWidth: "lg", "data-testid": "page-skeleton-detail", children: [jsxs(Box, { sx: { mb: 4 }, children: [jsx(Skeleton, { variant: "text", width: "40%", height: 48 }), jsx(Skeleton, { variant: "text", width: "25%", height: 24 })] }), jsxs(Grid, { container: true, spacing: 4, children: [jsxs(Grid, { xs: 12, md: 8, children: [jsx(Skeleton, { variant: "rectangular", height: 400, sx: { borderRadius: 2, mb: 3 } }), jsx(Skeleton, { variant: "text", height: 32, sx: { mb: 1 } }), jsx(Skeleton, { variant: "text", height: 24 }), jsx(Skeleton, { variant: "text", height: 24 }), jsx(Skeleton, { variant: "text", height: 24, width: "80%" })] }), jsxs(Grid, { xs: 12, md: 4, children: [jsx(Skeleton, { variant: "rectangular", height: 200, sx: { borderRadius: 2, mb: 2 } }), jsx(Skeleton, { variant: "rectangular", height: 150, sx: { borderRadius: 2 } })] })] })] }));
    }
    // Default grid layout
    return (jsxs(Container, { maxWidth: "lg", "data-testid": "page-skeleton-default", children: [jsxs(Box, { sx: { mb: 4 }, children: [jsx(Skeleton, { variant: "text", width: "30%", height: 48 }), jsx(Skeleton, { variant: "text", width: "50%", height: 24 })] }), jsx(Grid, { container: true, spacing: 3, children: Array.from({ length: 6 }, function (_, i) { return (jsx(Grid, { item: true, xs: 12, sm: 6, md: 4, children: jsx(Skeleton, { variant: "rectangular", height: 300, sx: { borderRadius: 2 } }) }, i)); }) })] }));
};

/**
 * TableSkeleton - Table loading placeholder
 */
var TableSkeleton = function (_a) {
    var _b = _a.rows, rows = _b === void 0 ? 5 : _b, _c = _a.columns, columns = _c === void 0 ? 4 : _c;
    return (jsxs(Table, { "data-testid": "table-skeleton", children: [jsx(TableHead, { children: jsx(TableRow, { children: Array.from({ length: columns }, function (_, i) { return (jsx(TableCell, { children: jsx(Skeleton, { variant: "text", width: "80%", height: 24 }) }, i)); }) }) }), jsx(TableBody, { children: Array.from({ length: rows }, function (_, rowIndex) { return (jsx(TableRow, { children: Array.from({ length: columns }, function (_, colIndex) { return (jsx(TableCell, { children: jsx(Skeleton, { variant: "text", width: colIndex === 0 ? '90%' : '70%', height: 20 }) }, colIndex)); }) }, rowIndex)); }) })] }));
};

/**
 * TextField - Controlled text input with React Hook Form integration
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * <TextField
 *   name="email"
 *   control={control}
 *   label="Email"
 *   type="email"
 *   required
 *   startIcon={<Email />}
 * />
 * ```
 */
function TextField(_a) {
    var name = _a.name, control = _a.control, label = _a.label, _b = _a.type, type = _b === void 0 ? 'text' : _b, _c = _a.required, required = _c === void 0 ? false : _c, _d = _a.rules, rules = _d === void 0 ? {} : _d, startIcon = _a.startIcon, endIcon = _a.endIcon, helperText = _a.helperText, placeholder = _a.placeholder, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.fullWidth, fullWidth = _f === void 0 ? true : _f, _g = _a.size, size = _g === void 0 ? 'medium' : _g, _h = _a.multiline, multiline = _h === void 0 ? false : _h, rows = _a.rows, _j = _a.autoFocus, autoFocus = _j === void 0 ? false : _j;
    return (jsx(Controller, { name: name, control: control, rules: _assign({ required: required ? "".concat(label, " is required") : false }, rules), render: function (_a) {
            var field = _a.field, error = _a.fieldState.error;
            return (jsx(TextField$1, _assign({}, field, { label: label, type: type, required: required, error: !!error, helperText: (error === null || error === void 0 ? void 0 : error.message) || helperText, placeholder: placeholder, disabled: disabled, fullWidth: fullWidth, size: size, multiline: multiline, rows: rows, autoFocus: autoFocus, InputProps: {
                    startAdornment: startIcon ? (jsx(InputAdornment, { position: "start", children: startIcon })) : undefined,
                    endAdornment: endIcon ? (jsx(InputAdornment, { position: "end", children: endIcon })) : undefined,
                }, "data-testid": "textfield-".concat(name) })));
        } }));
}

/**
 * SelectField - Controlled select input with React Hook Form integration
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * <SelectField
 *   name="propertyType"
 *   control={control}
 *   label="Property Type"
 *   options={[
 *     { value: 'apartment', label: 'Apartment' },
 *     { value: 'house', label: 'House' },
 *   ]}
 *   required
 * />
 * ```
 */
function SelectField(_a) {
    var name = _a.name, control = _a.control, label = _a.label, options = _a.options, _b = _a.required, required = _b === void 0 ? false : _b, _c = _a.rules, rules = _c === void 0 ? {} : _c, helperText = _a.helperText, _d = _a.disabled, disabled = _d === void 0 ? false : _d, _e = _a.fullWidth, fullWidth = _e === void 0 ? true : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, placeholder = _a.placeholder;
    return (jsx(Controller, { name: name, control: control, rules: _assign({ required: required ? "".concat(label, " is required") : false }, rules), render: function (_a) {
            var field = _a.field, error = _a.fieldState.error;
            return (jsxs(FormControl, { fullWidth: fullWidth, error: !!error, disabled: disabled, size: size, "data-testid": "selectfield-".concat(name), children: [jsx(InputLabel, { required: required, children: label }), jsxs(Select, _assign({}, field, { label: label, displayEmpty: !!placeholder, children: [placeholder && (jsx(MenuItem, { value: "", disabled: true, children: placeholder })), options.map(function (option) { return (jsx(MenuItem, { value: option.value, children: option.label }, option.value)); })] })), ((error === null || error === void 0 ? void 0 : error.message) || helperText) && (jsx(FormHelperText, { children: (error === null || error === void 0 ? void 0 : error.message) || helperText }))] }));
        } }));
}

/**
 * Formats bytes to human-readable size
 */
var formatFileSize = function (bytes) {
    if (bytes < 1024)
        return "".concat(bytes, " B");
    if (bytes < 1024 * 1024)
        return "".concat((bytes / 1024).toFixed(1), " KB");
    return "".concat((bytes / (1024 * 1024)).toFixed(1), " MB");
};
/**
 * FileUpload - Drag and drop file upload component
 *
 * @example
 * ```tsx
 * const [files, setFiles] = useState<UploadedFile[]>([]);
 *
 * <FileUpload
 *   files={files}
 *   onFilesSelected={(newFiles) => {
 *     setFiles(prev => [...prev, ...newFiles.map(f => ({
 *       name: f.name,
 *       size: f.size,
 *       status: 'pending'
 *     }))]);
 *   }}
 *   onFileRemove={(index) => {
 *     setFiles(prev => prev.filter((_, i) => i !== index));
 *   }}
 *   accept="image/*,.pdf"
 *   maxSize={10 * 1024 * 1024}
 * />
 * ```
 */
var FileUpload = function (_a) {
    var onFilesSelected = _a.onFilesSelected, onFileRemove = _a.onFileRemove, _b = _a.accept, accept = _b === void 0 ? '*' : _b, _c = _a.multiple, multiple = _c === void 0 ? true : _c, _d = _a.maxSize, maxSize = _d === void 0 ? 10 * 1024 * 1024 : _d, // 10MB default
    _e = _a.maxFiles, // 10MB default
    maxFiles = _e === void 0 ? 10 : _e, _f = _a.files, files = _f === void 0 ? [] : _f, _g = _a.uploading, uploading = _g === void 0 ? false : _g, _h = _a.uploadProgress, uploadProgress = _h === void 0 ? 0 : _h, error = _a.error, _j = _a.disabled, disabled = _j === void 0 ? false : _j;
    var _k = useState(false), isDragging = _k[0], setIsDragging = _k[1];
    var handleDragOver = useCallback(function (e) {
        e.preventDefault();
        if (!disabled) {
            setIsDragging(true);
        }
    }, [disabled]);
    var handleDragLeave = useCallback(function (e) {
        e.preventDefault();
        setIsDragging(false);
    }, []);
    var handleDrop = useCallback(function (e) {
        e.preventDefault();
        setIsDragging(false);
        if (disabled)
            return;
        var droppedFiles = Array.from(e.dataTransfer.files);
        onFilesSelected === null || onFilesSelected === void 0 ? void 0 : onFilesSelected(droppedFiles);
    }, [disabled, onFilesSelected]);
    var handleFileSelect = useCallback(function (e) {
        if (e.target.files) {
            var selectedFiles = Array.from(e.target.files);
            onFilesSelected === null || onFilesSelected === void 0 ? void 0 : onFilesSelected(selectedFiles);
            e.target.value = ''; // Reset input
        }
    }, [onFilesSelected]);
    var getStatusIcon = function (status) {
        switch (status) {
            case 'success':
                return jsx(CheckCircle, { color: "success", sx: { mr: 1 } });
            case 'error':
                return jsx(Error$1, { color: "error", sx: { mr: 1 } });
            default:
                return null;
        }
    };
    return (jsxs(Box, { "data-testid": "file-upload", children: [jsxs(Paper, { variant: "outlined", onDragOver: handleDragOver, onDragLeave: handleDragLeave, onDrop: handleDrop, sx: {
                    p: 4,
                    textAlign: 'center',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    bgcolor: isDragging ? 'action.hover' : 'background.paper',
                    borderStyle: 'dashed',
                    borderColor: isDragging ? 'primary.main' : 'divider',
                    opacity: disabled ? 0.6 : 1,
                    transition: 'all 0.2s',
                    '&:hover': disabled
                        ? {}
                        : {
                            borderColor: 'primary.main',
                            bgcolor: 'action.hover',
                        },
                }, "data-testid": "file-upload-dropzone", children: [jsx("input", { type: "file", accept: accept, multiple: multiple, onChange: handleFileSelect, style: { display: 'none' }, id: "file-upload-input", "data-testid": "file-upload-input", disabled: disabled }), jsxs("label", { htmlFor: "file-upload-input", style: { cursor: disabled ? 'not-allowed' : 'pointer' }, children: [jsx(CloudUpload, { sx: { fontSize: 48, color: 'primary.main', mb: 1 } }), jsx(Typography, { variant: "h6", gutterBottom: true, children: "Drag & drop files here" }), jsx(Typography, { variant: "body2", color: "text.secondary", gutterBottom: true, children: "or click to browse" }), jsxs(Typography, { variant: "caption", color: "text.secondary", children: ["Max file size: ", formatFileSize(maxSize), multiple && " \u2022 Max files: ".concat(maxFiles)] })] })] }), uploading && (jsxs(Box, { sx: { mt: 2 }, children: [jsx(LinearProgress, { variant: "determinate", value: uploadProgress }), jsxs(Typography, { variant: "caption", color: "text.secondary", children: ["Uploading... ", uploadProgress, "%"] })] })), error && (jsx(Typography, { color: "error", variant: "body2", sx: { mt: 1 }, children: error })), files.length > 0 && (jsx(List, { sx: { mt: 2 }, "data-testid": "file-upload-list", children: files.map(function (file, index) { return (jsxs(ListItem, { sx: {
                        bgcolor: 'background.paper',
                        borderRadius: 1,
                        mb: 1,
                        border: '1px solid',
                        borderColor: file.status === 'error' ? 'error.main' : 'divider',
                    }, children: [jsx(InsertDriveFile, { sx: { mr: 2, color: 'primary.main' } }), jsx(ListItemText, { primary: file.name, secondary: file.error || formatFileSize(file.size), secondaryTypographyProps: {
                                color: file.status === 'error' ? 'error' : 'text.secondary',
                            } }), getStatusIcon(file.status), jsx(ListItemSecondaryAction, { children: jsx(IconButton, { edge: "end", onClick: function () { return onFileRemove === null || onFileRemove === void 0 ? void 0 : onFileRemove(index); }, "data-testid": "file-remove-".concat(index), disabled: disabled, children: jsx(Delete, {}) }) })] }, "".concat(file.name, "-").concat(index))); }) }))] }));
};

/**
 * FormSection - Groups form fields with a title and description
 *
 * @example
 * ```tsx
 * <FormSection
 *   title="Personal Information"
 *   description="Please provide your contact details"
 * >
 *   <TextField name="firstName" control={control} label="First Name" />
 *   <TextField name="lastName" control={control} label="Last Name" />
 * </FormSection>
 * ```
 */
var FormSection = function (_a) {
    var title = _a.title, description = _a.description, children = _a.children, _b = _a.showDivider, showDivider = _b === void 0 ? false : _b, _c = _a.spacing, spacing = _c === void 0 ? 2 : _c;
    return (jsxs(Box, { sx: { mb: 4 }, "data-testid": "form-section", children: [title && (jsx(Typography, { variant: "h6", gutterBottom: true, sx: { fontWeight: 600 }, children: title })), description && (jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mb: 2 }, children: description })), jsx(Box, { sx: { display: 'flex', flexDirection: 'column', gap: spacing }, children: children }), showDivider && jsx(Divider, { sx: { mt: 4 } })] }));
};

/**
 * PageHeader - Consistent page header with title, breadcrumbs, and actions
 *
 * @example
 * <PageHeader
 *   title="Properties"
 *   subtitle="Browse verified investment properties"
 *   breadcrumbs={[
 *     { label: 'Home', href: '/' },
 *     { label: 'Properties' },
 *   ]}
 *   actions={<Button variant="contained">Add Property</Button>}
 * />
 */
var PageHeader = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, _b = _a.breadcrumbs, breadcrumbs = _b === void 0 ? [] : _b, actions = _a.actions, _c = _a.backButton, backButton = _c === void 0 ? false : _c, onBack = _a.onBack, _d = _a.backLabel, backLabel = _d === void 0 ? 'Back' : _d, sx = _a.sx;
    return (jsxs(Box, { sx: _assign({ mb: 4 }, sx), "data-testid": "page-header", children: [breadcrumbs.length > 0 && (jsx(Breadcrumbs, { separator: jsx(NavigateNext, { fontSize: "small" }), sx: { mb: 1 }, "aria-label": "breadcrumb", children: breadcrumbs.map(function (crumb, index) {
                    var isLast = index === breadcrumbs.length - 1;
                    if (isLast) {
                        return (jsx(Typography, { color: "text.primary", variant: "body2", "aria-current": "page", children: crumb.label }, index));
                    }
                    if (crumb.onClick) {
                        return (jsx(Link, { component: "button", onClick: crumb.onClick, color: "inherit", underline: "hover", variant: "body2", sx: { cursor: 'pointer' }, children: crumb.label }, index));
                    }
                    return (jsx(Link, { href: crumb.href, color: "inherit", underline: "hover", variant: "body2", children: crumb.label }, index));
                }) })), jsxs(Stack, { direction: { xs: 'column', sm: 'row' }, justifyContent: "space-between", alignItems: { xs: 'flex-start', sm: 'center' }, spacing: 2, children: [jsxs(Box, { children: [backButton && (jsx(Button$1, { onClick: onBack, startIcon: jsx(ArrowBack, {}), sx: { mb: 1, ml: -1 }, size: "small", color: "inherit", children: backLabel })), jsx(Typography, { variant: "h4", component: "h1", fontWeight: "bold", children: title }), subtitle && (jsx(Typography, { variant: "body1", color: "text.secondary", sx: { mt: 0.5 }, children: subtitle }))] }), actions && (jsx(Stack, { direction: "row", spacing: 1, flexShrink: 0, children: actions }))] })] }));
};

/**
 * SectionCard - Card wrapper for content sections with optional header
 *
 * @example
 * <SectionCard
 *   title="Property Details"
 *   subtitle="Basic information about the property"
 *   action={<Button size="small">Edit</Button>}
 * >
 *   <PropertyForm />
 * </SectionCard>
 */
var SectionCard = function (_a) {
    var title = _a.title, subtitle = _a.subtitle, action = _a.action, children = _a.children, _b = _a.noPadding, noPadding = _b === void 0 ? false : _b, _c = _a.elevation, elevation = _c === void 0 ? 0 : _c, sx = _a.sx, contentSx = _a.contentSx, _d = _a.showDivider, showDivider = _d === void 0 ? true : _d;
    var hasHeader = title || action;
    return (jsxs(Card$1, { elevation: elevation, sx: _assign({ borderRadius: 3, border: '1px solid', borderColor: 'divider' }, sx), "data-testid": "section-card", children: [hasHeader && (jsxs(Fragment, { children: [jsxs(Box, { sx: {
                            px: 3,
                            py: 2,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            minHeight: 64,
                        }, children: [jsxs(Box, { children: [title && (jsx(Typography, { variant: "h6", fontWeight: 600, children: title })), subtitle && (jsx(Typography, { variant: "body2", color: "text.secondary", sx: { mt: 0.25 }, children: subtitle }))] }), action && jsx(Box, { flexShrink: 0, children: action })] }), showDivider && jsx(Divider, {})] })), noPadding ? (jsx(Box, { sx: contentSx, children: children })) : (jsx(CardContent, { sx: _assign({ p: 3, '&:last-child': { pb: 3 } }, contentSx), children: children }))] }));
};

var variantConfig = {
    default: {
        icon: Inbox,
        title: 'No items found',
        description: 'There are no items to display at this time.',
    },
    search: {
        icon: Search,
        title: 'No results found',
        description: 'Try adjusting your search or filter criteria.',
    },
    create: {
        icon: Add,
        title: 'Nothing here yet',
        description: 'Get started by creating your first item.',
    },
    error: {
        icon: ErrorOutline,
        title: 'Something went wrong',
        description: 'We encountered an error. Please try again.',
    },
    folder: {
        icon: FolderOpen,
        title: 'This folder is empty',
        description: 'Add files or folders to get started.',
    },
};
var iconSizeMap = {
    small: { container: 60, icon: 28 },
    medium: { container: 80, icon: 40 },
    large: { container: 100, icon: 50 },
};
/**
 * EmptyState - Placeholder for empty lists/pages
 *
 * @example
 * // Basic usage
 * <EmptyState
 *   title="No properties found"
 *   description="Try adjusting your filters"
 *   actionLabel="Clear Filters"
 *   onAction={handleClearFilters}
 * />
 *
 * // Using preset variant
 * <EmptyState
 *   variant="search"
 *   actionLabel="Clear Search"
 *   onAction={handleClear}
 * />
 */
var EmptyState = function (_a) {
    var icon = _a.icon, title = _a.title, description = _a.description, actionLabel = _a.actionLabel, onAction = _a.onAction, secondaryActionLabel = _a.secondaryActionLabel, onSecondaryAction = _a.onSecondaryAction, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, sx = _a.sx, _c = _a.iconSize, iconSize = _c === void 0 ? 'medium' : _c;
    var config = variantConfig[variant];
    var DisplayIcon = icon || config.icon;
    var displayTitle = title || config.title;
    var displayDescription = description !== null && description !== void 0 ? description : config.description;
    var sizes = iconSizeMap[iconSize];
    return (jsxs(Box, { sx: _assign({ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', py: 8, px: 2, textAlign: 'center' }, sx), "data-testid": "empty-state", children: [jsx(Box, { sx: {
                    width: sizes.container,
                    height: sizes.container,
                    borderRadius: '50%',
                    bgcolor: 'action.hover',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 3,
                }, children: jsx(DisplayIcon, { sx: { fontSize: sizes.icon, color: 'text.secondary' }, "data-testid": "empty-state-icon" }) }), jsx(Typography, { variant: "h6", gutterBottom: true, fontWeight: 600, children: displayTitle }), displayDescription && (jsx(Typography, { variant: "body2", color: "text.secondary", sx: { maxWidth: 400, mb: actionLabel ? 3 : 0 }, children: displayDescription })), (actionLabel || secondaryActionLabel) && (jsxs(Box, { sx: { display: 'flex', gap: 2, mt: 1 }, children: [secondaryActionLabel && onSecondaryAction && (jsx(Button$1, { variant: "outlined", onClick: onSecondaryAction, children: secondaryActionLabel })), actionLabel && onAction && (jsx(Button$1, { variant: "contained", onClick: onAction, children: actionLabel }))] }))] }));
};

/**
 * ClickableCard - Styled card with optional hover effects
 *
 * @example
 * <ClickableCard clickable onClick={handleClick}>
 *   <CardContent>
 *     <Typography>Click me!</Typography>
 *   </CardContent>
 * </ClickableCard>
 */
var ClickableCard = styled(Card$1, {
    shouldForwardProp: function (prop) { return prop !== 'clickable'; },
})(function (_a) {
    var theme = _a.theme, _b = _a.clickable, clickable = _b === void 0 ? false : _b;
    return (_assign({ borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.05)', transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out', position: 'relative', overflow: 'visible', cursor: clickable ? 'pointer' : 'default' }, (clickable && {
        '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 12px 24px rgba(0,0,0,0.1)',
        },
        '&:active': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 16px rgba(0,0,0,0.08)',
        },
        '&:focus-visible': {
            outline: "2px solid ".concat(theme.palette.primary.main),
            outlineOffset: 2,
        },
    })));
});

/**
 * useAsync - Hook for managing async operation state
 *
 * @param options - Configuration options
 * @returns Object with execute function and state
 *
 * @example
 * ```tsx
 * const { execute, loading, data, error } = useAsync<User[]>();
 *
 * useEffect(() => {
 *   execute(() => api.get('/users'));
 * }, [execute]);
 *
 * if (loading) return <Spinner />;
 * if (error) return <Error message={error} />;
 * return <UserList users={data} />;
 * ```
 */
function useAsync(options) {
    var _this = this;
    if (options === void 0) { options = {}; }
    var onError = options.onError, onSuccess = options.onSuccess;
    var _a = useState('idle'), status = _a[0], setStatus = _a[1];
    var _b = useState(null), data = _b[0], setData = _b[1];
    var _c = useState(null), error = _c[0], setError = _c[1];
    var execute = useCallback(function (asyncFunction) { return __awaiter(_this, void 0, void 0, function () {
        var response, err_1, errorObj, errorMessage;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setStatus('pending');
                    setData(null);
                    setError(null);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, asyncFunction()];
                case 2:
                    response = _c.sent();
                    setData(response);
                    setStatus('success');
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(response);
                    return [2 /*return*/, response];
                case 3:
                    err_1 = _c.sent();
                    errorObj = err_1;
                    errorMessage = ((_b = (_a = errorObj.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || errorObj.message || 'An unexpected error occurred';
                    setError(errorMessage);
                    setStatus('error');
                    onError === null || onError === void 0 ? void 0 : onError(errorMessage, errorObj);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [onError, onSuccess]);
    var reset = useCallback(function () {
        setStatus('idle');
        setData(null);
        setError(null);
    }, []);
    return {
        execute: execute,
        status: status,
        data: data,
        error: error,
        loading: status === 'pending',
        isIdle: status === 'idle',
        isSuccess: status === 'success',
        isError: status === 'error',
        reset: reset,
    };
}

var NotificationContext = createContext(null);
/**
 * useNotification - Hook for showing toast notifications
 *
 * @returns Object with notification methods
 *
 * @example
 * ```tsx
 * const { showSuccess, showError } = useNotification();
 *
 * const handleSave = async () => {
 *   try {
 *     await saveData();
 *     showSuccess('Data saved successfully!');
 *   } catch (error) {
 *     showError('Failed to save data');
 *   }
 * };
 * ```
 */
function useNotification() {
    var context = useContext(NotificationContext);
    // Return no-op functions if used outside provider (graceful degradation)
    if (!context) {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        var noop = function () { };
        return {
            showSuccess: noop,
            showError: noop,
            showInfo: noop,
            showWarning: noop,
        };
    }
    return context;
}
/**
 * NotificationProvider - Provides notification context to children
 *
 * @example
 * ```tsx
 * <NotificationProvider autoHideDuration={5000}>
 *   <App />
 * </NotificationProvider>
 * ```
 */
var NotificationProvider = function (_a) {
    var children = _a.children, _b = _a.autoHideDuration, autoHideDuration = _b === void 0 ? 4000 : _b, _c = _a.anchorOrigin, anchorOrigin = _c === void 0 ? { vertical: 'bottom', horizontal: 'center' } : _c;
    var _d = useState(false), open = _d[0], setOpen = _d[1];
    var _e = useState(''), message = _e[0], setMessage = _e[1];
    var _f = useState('info'), severity = _f[0], setSeverity = _f[1];
    var showNotification = useCallback(function (msg, type) {
        if (type === void 0) { type = 'info'; }
        setMessage(msg);
        setSeverity(type);
        setOpen(true);
    }, []);
    var showSuccess = useCallback(function (msg) { return showNotification(msg, 'success'); }, [showNotification]);
    var showError = useCallback(function (msg) { return showNotification(msg, 'error'); }, [showNotification]);
    var showInfo = useCallback(function (msg) { return showNotification(msg, 'info'); }, [showNotification]);
    var showWarning = useCallback(function (msg) { return showNotification(msg, 'warning'); }, [showNotification]);
    var handleClose = function (_event, reason) {
        if (reason === 'clickaway')
            return;
        setOpen(false);
    };
    var value = {
        showSuccess: showSuccess,
        showError: showError,
        showInfo: showInfo,
        showWarning: showWarning,
    };
    return (jsxs(NotificationContext.Provider, { value: value, children: [children, jsx(Snackbar, { open: open, autoHideDuration: autoHideDuration, onClose: handleClose, anchorOrigin: anchorOrigin, children: jsx(Alert, { onClose: handleClose, severity: severity, sx: { width: '100%', fontWeight: 500 }, "data-testid": "notification-alert", children: message }) })] }));
};

/**
 * AuthContext - Context for authentication state
 *
 * This context should be created and provided by the consuming application
 * because the actual auth implementation depends on the specific auth service.
 *
 * @example
 * ```tsx
 * // In your app
 * import { AuthContext, AuthContextValue } from '@bomatrust/shared';
 *
 * const AuthProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
 *   const [user, setUser] = useState<User | null>(null);
 *   // ... implement auth logic
 *
 *   const value: AuthContextValue = {
 *     user,
 *     loading,
 *     error,
 *     isAuthenticated: !!user,
 *     login,
 *     logout,
 *     register,
 *   };
 *
 *   return (
 *     <AuthContext.Provider value={value}>
 *       {children}
 *     </AuthContext.Provider>
 *   );
 * };
 * ```
 */
var AuthContext = createContext(null);
/**
 * useAuth - Hook for accessing authentication context
 *
 * @returns AuthContextValue
 * @throws Error if used outside AuthProvider
 *
 * @example
 * ```tsx
 * const { user, isAuthenticated, login, logout } = useAuth();
 *
 * if (!isAuthenticated) {
 *   return <Navigate to="/login" />;
 * }
 *
 * return <div>Welcome, {user.firstName}!</div>;
 * ```
 */
function useAuth() {
    var context = useContext(AuthContext);
    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
}
/**
 * Type guard to check if user has a specific role
 */
function hasRole(user, role) {
    var _a;
    if (!user)
        return false;
    var actualRole = (_a = user.role) !== null && _a !== void 0 ? _a : user.userType;
    return actualRole === role;
}
/**
 * Type guard to check if user has any of the specified roles
 */
function hasAnyRole(user, roles) {
    var _a;
    if (!user)
        return false;
    var actualRole = (_a = user.role) !== null && _a !== void 0 ? _a : user.userType;
    return typeof actualRole === 'string' ? roles.includes(actualRole) : false;
}

/**
 * usePagination - Hook for managing pagination state
 *
 * @example
 * const {
 *   page,
 *   pageSize,
 *   setPage,
 *   nextPage,
 *   paginationParams,
 * } = usePagination({ total: 100, initialPageSize: 20 });
 *
 * // Use with API
 * const { data } = useQuery(['items', paginationParams], () =>
 *   fetchItems(paginationParams)
 * );
 */
var usePagination = function (options) {
    if (options === void 0) { options = {}; }
    var _a = options.initialPage, initialPage = _a === void 0 ? 1 : _a, _b = options.initialPageSize, initialPageSize = _b === void 0 ? 20 : _b, _c = options.total, total = _c === void 0 ? 0 : _c;
    var _d = useState(initialPage), page = _d[0], setPageState = _d[1];
    var _e = useState(initialPageSize), pageSize = _e[0], setPageSizeState = _e[1];
    var totalPages = useMemo(function () {
        return Math.ceil(total / pageSize) || 1;
    }, [total, pageSize]);
    var hasNextPage = useMemo(function () { return page < totalPages; }, [page, totalPages]);
    var hasPrevPage = useMemo(function () { return page > 1; }, [page]);
    var isFirstPage = page === 1;
    var isLastPage = page === totalPages;
    var setPage = useCallback(function (newPage) {
        var validPage = Math.max(1, Math.min(newPage, totalPages));
        setPageState(validPage);
    }, [totalPages]);
    var nextPage = useCallback(function () {
        if (hasNextPage) {
            setPageState(function (prev) { return prev + 1; });
        }
    }, [hasNextPage]);
    var prevPage = useCallback(function () {
        if (hasPrevPage) {
            setPageState(function (prev) { return prev - 1; });
        }
    }, [hasPrevPage]);
    var setPageSize = useCallback(function (newSize) {
        setPageSizeState(newSize);
        setPageState(1); // Reset to first page when changing page size
    }, []);
    var reset = useCallback(function () {
        setPageState(initialPage);
        setPageSizeState(initialPageSize);
    }, [initialPage, initialPageSize]);
    // Calculate offset for API calls (0-indexed)
    var offset = useMemo(function () { return (page - 1) * pageSize; }, [page, pageSize]);
    return {
        // State
        page: page,
        pageSize: pageSize,
        total: total,
        totalPages: totalPages,
        offset: offset,
        // Computed
        hasNextPage: hasNextPage,
        hasPrevPage: hasPrevPage,
        isFirstPage: isFirstPage,
        isLastPage: isLastPage,
        // Actions
        setPage: setPage,
        setPageSize: setPageSize,
        nextPage: nextPage,
        prevPage: prevPage,
        reset: reset,
        // For API params
        paginationParams: { page: page, limit: pageSize, offset: offset },
    };
};

/**
 * useDebounce - Hook for debouncing a value
 *
 * @param value - Value to debounce
 * @param delay - Delay in milliseconds (default: 300)
 * @returns Debounced value
 *
 * @example
 * const [searchTerm, setSearchTerm] = useState('');
 * const debouncedSearch = useDebounce(searchTerm, 500);
 *
 * useEffect(() => {
 *   // This runs 500ms after the user stops typing
 *   searchApi(debouncedSearch);
 * }, [debouncedSearch]);
 */
function useDebounce(value, delay) {
    if (delay === void 0) { delay = 300; }
    var _a = useState(value), debouncedValue = _a[0], setDebouncedValue = _a[1];
    useEffect(function () {
        var timer = setTimeout(function () {
            setDebouncedValue(value);
        }, delay);
        return function () {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return debouncedValue;
}
/**
 * useDebouncedCallback - Hook for debouncing a callback function
 *
 * @param callback - Function to debounce
 * @param delay - Delay in milliseconds
 * @returns Debounced callback and cancel function
 *
 * @example
 * const { debouncedCallback, cancel } = useDebouncedCallback((value: string) => {
 *   saveToApi(value);
 * }, 500);
 *
 * // Call it like a normal function
 * debouncedCallback('new value');
 *
 * // Cancel pending calls if needed
 * cancel();
 */
function useDebouncedCallback(callback, delay) {
    if (delay === void 0) { delay = 300; }
    var timeoutRef = useRef(null);
    var callbackRef = useRef(callback);
    var argsRef = useRef(null);
    // Update callback ref when callback changes
    useEffect(function () {
        callbackRef.current = callback;
    }, [callback]);
    var cancel = useCallback(function () {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        argsRef.current = null;
    }, []);
    var flush = useCallback(function () {
        if (timeoutRef.current && argsRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
            callbackRef.current.apply(callbackRef, argsRef.current);
            argsRef.current = null;
        }
    }, []);
    var debouncedCallback = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        argsRef.current = args;
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(function () {
            callbackRef.current.apply(callbackRef, args);
            timeoutRef.current = null;
            argsRef.current = null;
        }, delay);
    }, [delay]);
    // Cleanup on unmount
    useEffect(function () {
        return function () {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
    return { debouncedCallback: debouncedCallback, cancel: cancel, flush: flush };
}

/**
 * useLocalStorage - Hook for persisting state to localStorage
 *
 * @param key - localStorage key
 * @param initialValue - Initial value if key doesn't exist
 * @returns [value, setValue, removeValue]
 *
 * @example
 * const [theme, setTheme, removeTheme] = useLocalStorage('theme', 'light');
 *
 * // Update value
 * setTheme('dark');
 *
 * // Use function updater
 * setTheme(prev => prev === 'light' ? 'dark' : 'light');
 *
 * // Remove from storage
 * removeTheme();
 */
function useLocalStorage(key, initialValue) {
    // Get initial value from localStorage or use provided initial value
    var _a = useState(function () {
        if (typeof window === 'undefined') {
            return initialValue;
        }
        try {
            var item = window.localStorage.getItem(key);
            return item ? JSON.parse(item) : initialValue;
        }
        catch (error) {
            console.warn("Error reading localStorage key \"".concat(key, "\":"), error);
            return initialValue;
        }
    }), storedValue = _a[0], setStoredValue = _a[1];
    // Update localStorage when value changes
    var setValue = useCallback(function (value) {
        try {
            // Allow value to be a function (like useState)
            var valueToStore = value instanceof Function ? value(storedValue) : value;
            setStoredValue(valueToStore);
            if (typeof window !== 'undefined') {
                window.localStorage.setItem(key, JSON.stringify(valueToStore));
            }
        }
        catch (error) {
            console.warn("Error setting localStorage key \"".concat(key, "\":"), error);
        }
    }, [key, storedValue]);
    // Remove from localStorage
    var removeValue = useCallback(function () {
        try {
            setStoredValue(initialValue);
            if (typeof window !== 'undefined') {
                window.localStorage.removeItem(key);
            }
        }
        catch (error) {
            console.warn("Error removing localStorage key \"".concat(key, "\":"), error);
        }
    }, [key, initialValue]);
    // Listen for changes in other tabs/windows
    useEffect(function () {
        var handleStorageChange = function (e) {
            if (e.key === key && e.newValue !== null) {
                try {
                    setStoredValue(JSON.parse(e.newValue));
                }
                catch (error) {
                    console.warn("Error parsing localStorage change for \"".concat(key, "\":"), error);
                }
            }
            else if (e.key === key && e.newValue === null) {
                // Key was removed
                setStoredValue(initialValue);
            }
        };
        window.addEventListener('storage', handleStorageChange);
        return function () { return window.removeEventListener('storage', handleStorageChange); };
    }, [key, initialValue]);
    return [storedValue, setValue, removeValue];
}

/**
 * useMediaQuery - Hook for responsive design
 *
 * @param query - Media query string
 * @returns Whether the media query matches
 *
 * @example
 * const isMobile = useMediaQuery('(max-width: 599px)');
 * const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
 *
 * if (isMobile) {
 *   return <MobileLayout />;
 * }
 */
function useMediaQuery(query) {
    var _a = useState(function () {
        if (typeof window !== 'undefined') {
            return window.matchMedia(query).matches;
        }
        return false;
    }), matches = _a[0], setMatches = _a[1];
    useEffect(function () {
        if (typeof window === 'undefined')
            return;
        var mediaQuery = window.matchMedia(query);
        var handleChange = function (e) {
            setMatches(e.matches);
        };
        // Set initial value
        setMatches(mediaQuery.matches);
        // Listen for changes
        mediaQuery.addEventListener('change', handleChange);
        return function () {
            mediaQuery.removeEventListener('change', handleChange);
        };
    }, [query]);
    return matches;
}
// MUI breakpoints: xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536
/**
 * Check if viewport is mobile (< 600px)
 */
var useIsMobile = function () { return useMediaQuery('(max-width: 599px)'); };
/**
 * Check if viewport is tablet (600px - 899px)
 */
var useIsTablet = function () {
    return useMediaQuery('(min-width: 600px) and (max-width: 899px)');
};
/**
 * Check if viewport is desktop (>= 900px)
 */
var useIsDesktop = function () { return useMediaQuery('(min-width: 900px)'); };
/**
 * Check if viewport is large desktop (>= 1200px)
 */
var useIsLargeDesktop = function () { return useMediaQuery('(min-width: 1200px)'); };
/**
 * Check if user prefers dark mode
 */
var usePrefersDarkMode = function () { return useMediaQuery('(prefers-color-scheme: dark)'); };
/**
 * Check if user prefers reduced motion
 */
var usePrefersReducedMotion = function () {
    return useMediaQuery('(prefers-reduced-motion: reduce)');
};

/**
 * Creates a configured Axios instance for API calls
 *
 * @param config - Configuration options
 * @returns Configured Axios instance
 *
 * @example
 * ```ts
 * // Basic usage with defaults
 * const api = createApiClient();
 *
 * // Custom configuration
 * const api = createApiClient({
 *   baseURL: 'https://api.bomatrust.com/v1',
 *   getToken: () => sessionStorage.getItem('token'),
 *   onAuthError: () => router.push('/login'),
 * });
 * ```
 */
// Helper to get API URL from environment (works in both CRA and Vite)
var getDefaultApiUrl = function () {
    var _a;
    // Optional runtime override (useful for non-CRA bundlers)
    if (typeof globalThis !== 'undefined') {
        var globalApiUrl = globalThis
            .__BOMATRUST_API_URL__;
        if (globalApiUrl)
            return globalApiUrl;
    }
    // CRA uses process.env
    if (typeof process !== 'undefined' && ((_a = process.env) === null || _a === void 0 ? void 0 : _a.REACT_APP_API_URL)) {
        return process.env.REACT_APP_API_URL;
    }
    return 'http://localhost:4080/api/v1';
};
function createApiClient(config) {
    var _this = this;
    if (config === void 0) { config = {}; }
    var _a = config.baseURL, baseURL = _a === void 0 ? getDefaultApiUrl() : _a, _b = config.getToken, getToken = _b === void 0 ? function () { return localStorage.getItem('token'); } : _b, _c = config.getRefreshToken, getRefreshToken = _c === void 0 ? function () { return localStorage.getItem('refreshToken'); } : _c, _d = config.setTokens, setTokens = _d === void 0 ? function (token, refreshToken) {
        localStorage.setItem('token', token);
        if (refreshToken)
            localStorage.setItem('refreshToken', refreshToken);
    } : _d, _e = config.clearTokens, clearTokens = _e === void 0 ? function () {
        localStorage.removeItem('token');
        localStorage.removeItem('refreshToken');
        localStorage.removeItem('user');
    } : _e, _f = config.onAuthError, onAuthError = _f === void 0 ? function () {
        window.location.href = '/login';
    } : _f, _g = config.refreshEndpoint, refreshEndpoint = _g === void 0 ? '/auth/refresh-token' : _g;
    var api = axios.create({
        baseURL: baseURL,
        headers: {
            'Content-Type': 'application/json',
        },
    });
    // Request Interceptor: Attach Token
    api.interceptors.request.use(function (requestConfig) {
        var token = getToken();
        if (token && requestConfig.headers) {
            requestConfig.headers.Authorization = "Bearer ".concat(token);
        }
        return requestConfig;
    }, function (error) { return Promise.reject(error); });
    // Response Interceptor: Handle 401s with token refresh
    api.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(_this, void 0, void 0, function () {
        var originalRequest, refreshToken, response, _a, accessToken, newRefreshToken, refreshError_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    originalRequest = error.config;
                    if (!(((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) === 401 && !originalRequest._retry)) return [3 /*break*/, 6];
                    originalRequest._retry = true;
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 4, , 5]);
                    refreshToken = getRefreshToken();
                    if (!refreshToken) return [3 /*break*/, 3];
                    return [4 /*yield*/, axios.post("".concat(baseURL).concat(refreshEndpoint), {
                            refreshToken: refreshToken,
                        })];
                case 2:
                    response = _c.sent();
                    _a = response.data.data || response.data, accessToken = _a.accessToken, newRefreshToken = _a.refreshToken;
                    // Update stored tokens
                    setTokens(accessToken, newRefreshToken);
                    // Update headers for retry
                    api.defaults.headers.common['Authorization'] = "Bearer ".concat(accessToken);
                    if (originalRequest.headers) {
                        originalRequest.headers['Authorization'] = "Bearer ".concat(accessToken);
                    }
                    // Retry original request
                    return [2 /*return*/, api(originalRequest)];
                case 3: return [3 /*break*/, 5];
                case 4:
                    refreshError_1 = _c.sent();
                    console.error('Token refresh failed:', refreshError_1);
                    clearTokens();
                    onAuthError();
                    return [2 /*return*/, Promise.reject(refreshError_1)];
                case 5:
                    // No refresh token available
                    clearTokens();
                    onAuthError();
                    _c.label = 6;
                case 6: return [2 /*return*/, Promise.reject(error)];
            }
        });
    }); });
    return api;
}
// Default instance for simple usage
var api = createApiClient();

/**
 * Creates an auth service with the provided API client
 *
 * @param apiClient - Configured Axios instance
 * @returns Auth service methods
 *
 * @example
 * ```ts
 * import { createAuthService, createApiClient } from '@bomatrust/shared';
 *
 * const api = createApiClient({ baseURL: 'https://api.bomatrust.com' });
 * const authService = createAuthService(api);
 *
 * const { token, refreshToken } = await authService.login(email, password);
 * ```
 */
function createAuthService(apiClient) {
    var _this = this;
    return {
        /**
         * Login user
         */
        login: function (email, password) { return __awaiter(_this, void 0, void 0, function () {
            var response, _a, accessToken, refreshToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, apiClient.post('/auth/login', { email: email, password: password })];
                    case 1:
                        response = _b.sent();
                        _a = response.data.data || response.data, accessToken = _a.accessToken, refreshToken = _a.refreshToken;
                        return [2 /*return*/, { token: accessToken, refreshToken: refreshToken }];
                }
            });
        }); },
        /**
         * Logout user (revoke refresh token)
         */
        logout: function () { return __awaiter(_this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, apiClient.post('/auth/logout')];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        // Logout should succeed even if API call fails
                        console.warn('Logout API call failed:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        /**
         * Register new user
         */
        register: function (data) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.post('/auth/signup', data)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        /**
         * Get current user profile
         */
        getProfile: function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.get('/auth/me')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.data || response.data];
                }
            });
        }); },
        /**
         * Refresh access token
         */
        refreshToken: function (refreshToken) { return __awaiter(_this, void 0, void 0, function () {
            var response, _a, accessToken, newRefreshToken;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, apiClient.post('/auth/refresh-token', { refreshToken: refreshToken })];
                    case 1:
                        response = _b.sent();
                        _a = response.data.data || response.data, accessToken = _a.accessToken, newRefreshToken = _a.refreshToken;
                        return [2 /*return*/, { token: accessToken, refreshToken: newRefreshToken }];
                }
            });
        }); },
        /**
         * Request password reset email
         */
        forgotPassword: function (email) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.post('/auth/forgot-password', { email: email })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        /**
         * Reset password using token
         */
        resetPassword: function (token, password) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.post('/auth/reset-password', { token: token, password: password })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        /**
         * Verify email using token
         */
        verifyEmail: function (token) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.post('/auth/verify-email', { token: token })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        /**
         * Change password (authenticated)
         */
        changePassword: function (currentPassword, newPassword) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.post('/auth/change-password', { currentPassword: currentPassword, newPassword: newPassword })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    };
}
// Default instance using default API client
var authService = createAuthService(api);

/**
 * Creates a property service with the provided API client
 *
 * @param apiClient - Configured Axios instance
 * @returns Property service methods
 *
 * @example
 * ```ts
 * import { createPropertyService, createApiClient } from '@bomatrust/shared';
 *
 * const api = createApiClient({ baseURL: 'https://api.bomatrust.com' });
 * const propertyService = createPropertyService(api);
 *
 * const { properties, pagination } = await propertyService.getProperties({ page: 1, limit: 20 });
 * ```
 */
function createPropertyService(apiClient) {
    var _this = this;
    return {
        /**
         * Get paginated list of properties
         */
        getProperties: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (params) {
                var response;
                if (params === void 0) { params = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, apiClient.get('/properties', { params: params })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.data.data || response.data];
                    }
                });
            });
        },
        /**
         * Get single property by ID
         */
        getProperty: function (id) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.get("/properties/".concat(id))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.data || response.data];
                }
            });
        }); },
        /**
         * Search properties with filters
         */
        searchProperties: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (filters) {
                var response;
                if (filters === void 0) { filters = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, apiClient.get('/properties/search', { params: filters })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.data.data || response.data];
                    }
                });
            });
        },
        /**
         * Get featured properties
         */
        getFeaturedProperties: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (limit) {
                var response;
                if (limit === void 0) { limit = 6; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, apiClient.get('/properties/featured', { params: { limit: limit } })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, response.data.data || response.data];
                    }
                });
            });
        },
        /**
         * Toggle property favorite status
         */
        toggleFavorite: function (propertyId) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.post("/properties/".concat(propertyId, "/favorite"))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.data || response.data];
                }
            });
        }); },
        /**
         * Get user's favorite properties
         */
        getFavorites: function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.get('/properties/favorites')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.data || response.data];
                }
            });
        }); },
        /**
         * Create new property listing (seller)
         */
        createProperty: function (propertyData) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.post('/properties', propertyData)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.data || response.data];
                }
            });
        }); },
        /**
         * Update property listing (seller)
         */
        updateProperty: function (id, propertyData) { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.put("/properties/".concat(id), propertyData)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.data || response.data];
                }
            });
        }); },
        /**
         * Get seller's own listings
         */
        getMyListings: function () { return __awaiter(_this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.get('/properties/my-listings')];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.data || response.data];
                }
            });
        }); },
    };
}
// Default instance using default API client
var propertyService = createPropertyService(api);

/**
 * Boma Trust Brand Color Palette
 *
 * These colors are the foundation of the Boma Trust visual identity,
 * designed to convey trust, professionalism, and warmth.
 */
var bomatrustColors = {
    /** Trust Navy - Primary brand color, conveys authority and trust */
    trustNavy: '#14213D',
    trustNavyLight: '#2C3E50',
    trustNavyDark: '#000018',
    /** Home Gold - Secondary accent, conveys warmth and opportunity */
    homeGold: '#FCA311',
    homeGoldLight: '#FFD449',
    homeGoldDark: '#C37400',
    /** Verified Green - Success states, verified properties */
    verifiedGreen: '#1B9C6E',
    verifiedGreenLight: '#4CAF50',
    verifiedGreenDark: '#0D7A52',
    /** Alert Red - Error states, warnings */
    alertRed: '#C0392B',
    alertRedLight: '#E74C3C',
    alertRedDark: '#922B21',
    /** Caution Orange - Warning states */
    cautionOrange: '#E67E22',
    cautionOrangeLight: '#F39C12',
    cautionOrangeDark: '#D35400',
    /** Clarity Blue - Info states */
    clarityBlue: '#3A7CA5',
    clarityBlueLight: '#5DADE2',
    clarityBlueDark: '#2471A3',
    /** Neutral colors */
    white: '#FFFFFF',
    offWhite: '#F7F7F7',
    lightGray: '#E0E0E0',
    mediumGray: '#9E9E9E',
    darkGray: '#546E7A',
    black: '#000000',
};
/**
 * MUI Palette configuration using Boma Trust brand colors
 */
var palette = {
    primary: {
        main: bomatrustColors.trustNavy,
        light: bomatrustColors.trustNavyLight,
        dark: bomatrustColors.trustNavyDark,
        contrastText: bomatrustColors.white,
    },
    secondary: {
        main: bomatrustColors.homeGold,
        light: bomatrustColors.homeGoldLight,
        dark: bomatrustColors.homeGoldDark,
        contrastText: bomatrustColors.black,
    },
    success: {
        main: bomatrustColors.verifiedGreen,
        light: bomatrustColors.verifiedGreenLight,
        dark: bomatrustColors.verifiedGreenDark,
        contrastText: bomatrustColors.white,
    },
    error: {
        main: bomatrustColors.alertRed,
        light: bomatrustColors.alertRedLight,
        dark: bomatrustColors.alertRedDark,
        contrastText: bomatrustColors.white,
    },
    warning: {
        main: bomatrustColors.cautionOrange,
        light: bomatrustColors.cautionOrangeLight,
        dark: bomatrustColors.cautionOrangeDark,
        contrastText: bomatrustColors.white,
    },
    info: {
        main: bomatrustColors.clarityBlue,
        light: bomatrustColors.clarityBlueLight,
        dark: bomatrustColors.clarityBlueDark,
        contrastText: bomatrustColors.white,
    },
    background: {
        default: bomatrustColors.offWhite,
        paper: bomatrustColors.white,
    },
    text: {
        primary: bomatrustColors.trustNavy,
        secondary: bomatrustColors.darkGray,
        disabled: bomatrustColors.mediumGray,
    },
    divider: bomatrustColors.lightGray,
};

/**
 * Boma Trust Typography Configuration
 *
 * Uses Inter as the primary font family for its excellent readability
 * and professional appearance across all platforms.
 */
var fontFamily = '"Inter", "Roboto", "Helvetica", "Arial", sans-serif';
/**
 * Font weights used throughout the application
 */
var fontWeights = {
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
};
/**
 * MUI Typography configuration
 */
var typography = {
    fontFamily: fontFamily,
    // Headings
    h1: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.bold,
        fontSize: '2.5rem', // 40px
        lineHeight: 1.2,
        letterSpacing: '-0.01562em',
    },
    h2: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.bold,
        fontSize: '2rem', // 32px
        lineHeight: 1.25,
        letterSpacing: '-0.00833em',
    },
    h3: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.semiBold,
        fontSize: '1.75rem', // 28px
        lineHeight: 1.3,
        letterSpacing: '0em',
    },
    h4: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.semiBold,
        fontSize: '1.5rem', // 24px
        lineHeight: 1.35,
        letterSpacing: '0.00735em',
    },
    h5: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.medium,
        fontSize: '1.25rem', // 20px
        lineHeight: 1.4,
        letterSpacing: '0em',
    },
    h6: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.medium,
        fontSize: '1.125rem', // 18px
        lineHeight: 1.45,
        letterSpacing: '0.0075em',
    },
    // Body text
    body1: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.regular,
        fontSize: '1rem', // 16px
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
    },
    body2: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.regular,
        fontSize: '0.875rem', // 14px
        lineHeight: 1.5,
        letterSpacing: '0.01071em',
    },
    // Subtitles
    subtitle1: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.medium,
        fontSize: '1rem', // 16px
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
    },
    subtitle2: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.medium,
        fontSize: '0.875rem', // 14px
        lineHeight: 1.5,
        letterSpacing: '0.00714em',
    },
    // Buttons
    button: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.semiBold,
        fontSize: '0.875rem', // 14px
        lineHeight: 1.75,
        letterSpacing: '0.02857em',
        textTransform: 'none', // No uppercase for better readability
    },
    // Captions and overlines
    caption: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.regular,
        fontSize: '0.75rem', // 12px
        lineHeight: 1.66,
        letterSpacing: '0.03333em',
    },
    overline: {
        fontFamily: fontFamily,
        fontWeight: fontWeights.medium,
        fontSize: '0.625rem', // 10px
        lineHeight: 2.66,
        letterSpacing: '0.08333em',
        textTransform: 'uppercase',
    },
};

/**
 * Boma Trust MUI Component Overrides
 *
 * Customizes MUI components to match the Boma Trust design system.
 */
var components = {
    // ButtonBase - Global focus-visible styles for accessibility
    MuiButtonBase: {
        styleOverrides: {
            root: {
                '&:focus-visible': {
                    outline: "2px solid ".concat(bomatrustColors.trustNavy),
                    outlineOffset: 2,
                },
            },
        },
    },
    // Button overrides
    MuiButton: {
        styleOverrides: {
            root: {
                borderRadius: 8,
                padding: '10px 20px',
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: 'none',
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.12)',
                    transform: 'translateY(-1px)',
                },
                '&:active': {
                    transform: 'translateY(0)',
                },
                '&:focus-visible': {
                    outline: "2px solid ".concat(bomatrustColors.trustNavy),
                    outlineOffset: 2,
                },
            },
            contained: {
                '&:hover': {
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.15)',
                },
            },
            containedPrimary: {
                background: "linear-gradient(135deg, ".concat(bomatrustColors.trustNavy, " 0%, ").concat(bomatrustColors.trustNavyLight, " 100%)"),
                '&:hover': {
                    background: "linear-gradient(135deg, ".concat(bomatrustColors.trustNavyLight, " 0%, ").concat(bomatrustColors.trustNavy, " 100%)"),
                },
            },
            containedSecondary: {
                background: "linear-gradient(135deg, ".concat(bomatrustColors.homeGold, " 0%, ").concat(bomatrustColors.homeGoldLight, " 100%)"),
                '&:hover': {
                    background: "linear-gradient(135deg, ".concat(bomatrustColors.homeGoldLight, " 0%, ").concat(bomatrustColors.homeGold, " 100%)"),
                },
            },
            outlined: {
                borderWidth: 2,
                '&:hover': {
                    borderWidth: 2,
                },
            },
            sizeSmall: {
                padding: '6px 16px',
                fontSize: '0.8125rem',
            },
            sizeLarge: {
                padding: '14px 28px',
                fontSize: '1rem',
            },
        },
        defaultProps: {
            disableElevation: true,
        },
    },
    // Card overrides
    MuiCard: {
        styleOverrides: {
            root: {
                borderRadius: 12,
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
                transition: 'box-shadow 0.2s ease-in-out, transform 0.2s ease-in-out',
                '&:hover': {
                    boxShadow: '0px 8px 24px rgba(0, 0, 0, 0.1)',
                },
            },
        },
    },
    // CardContent overrides
    MuiCardContent: {
        styleOverrides: {
            root: {
                padding: 20,
                '&:last-child': {
                    paddingBottom: 20,
                },
            },
        },
    },
    // TextField overrides
    MuiTextField: {
        styleOverrides: {
            root: {
                '& .MuiOutlinedInput-root': {
                    borderRadius: 8,
                    transition: 'box-shadow 0.2s ease-in-out',
                    '&:hover': {
                        boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
                    },
                    '&.Mui-focused': {
                        boxShadow: "0px 0px 0px 3px ".concat(bomatrustColors.trustNavy, "20"),
                    },
                },
            },
        },
        defaultProps: {
            variant: 'outlined',
            fullWidth: true,
        },
    },
    // Link overrides for accessibility
    MuiLink: {
        styleOverrides: {
            root: {
                '&:focus-visible': {
                    outline: "2px solid ".concat(bomatrustColors.trustNavy),
                    outlineOffset: 2,
                    borderRadius: 2,
                },
            },
        },
    },
    // IconButton overrides for accessibility
    MuiIconButton: {
        styleOverrides: {
            root: {
                '&:focus-visible': {
                    outline: "2px solid ".concat(bomatrustColors.trustNavy),
                    outlineOffset: 2,
                },
            },
        },
    },
    // Chip overrides
    MuiChip: {
        styleOverrides: {
            root: {
                borderRadius: 6,
                fontWeight: 500,
            },
            colorSuccess: {
                backgroundColor: "".concat(bomatrustColors.verifiedGreen, "15"),
                color: bomatrustColors.verifiedGreen,
                border: "1px solid ".concat(bomatrustColors.verifiedGreen, "40"),
            },
            colorWarning: {
                backgroundColor: "".concat(bomatrustColors.cautionOrange, "15"),
                color: bomatrustColors.cautionOrange,
                border: "1px solid ".concat(bomatrustColors.cautionOrange, "40"),
            },
            colorError: {
                backgroundColor: "".concat(bomatrustColors.alertRed, "15"),
                color: bomatrustColors.alertRed,
                border: "1px solid ".concat(bomatrustColors.alertRed, "40"),
            },
        },
    },
    // Paper overrides
    MuiPaper: {
        styleOverrides: {
            root: {
                borderRadius: 8,
            },
            elevation1: {
                boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.06)',
            },
            elevation2: {
                boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.08)',
            },
            elevation3: {
                boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.1)',
            },
        },
    },
    // AppBar overrides
    MuiAppBar: {
        styleOverrides: {
            root: {
                boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.08)',
            },
        },
        defaultProps: {
            elevation: 0,
        },
    },
    // Drawer overrides
    MuiDrawer: {
        styleOverrides: {
            paper: {
                borderRight: 'none',
                boxShadow: '2px 0px 8px rgba(0, 0, 0, 0.05)',
            },
        },
    },
    // Tab overrides
    MuiTab: {
        styleOverrides: {
            root: {
                textTransform: 'none',
                fontWeight: 500,
                minWidth: 'auto',
                padding: '12px 16px',
            },
        },
    },
    // Alert overrides
    MuiAlert: {
        styleOverrides: {
            root: {
                borderRadius: 8,
            },
            standardSuccess: {
                backgroundColor: "".concat(bomatrustColors.verifiedGreen, "10"),
                color: bomatrustColors.verifiedGreenDark,
            },
            standardError: {
                backgroundColor: "".concat(bomatrustColors.alertRed, "10"),
                color: bomatrustColors.alertRedDark,
            },
            standardWarning: {
                backgroundColor: "".concat(bomatrustColors.cautionOrange, "10"),
                color: bomatrustColors.cautionOrangeDark,
            },
            standardInfo: {
                backgroundColor: "".concat(bomatrustColors.clarityBlue, "10"),
                color: bomatrustColors.clarityBlueDark,
            },
        },
    },
    // Tooltip overrides
    MuiTooltip: {
        styleOverrides: {
            tooltip: {
                backgroundColor: bomatrustColors.trustNavy,
                borderRadius: 6,
                fontSize: '0.75rem',
                padding: '8px 12px',
            },
            arrow: {
                color: bomatrustColors.trustNavy,
            },
        },
    },
    // Dialog overrides
    MuiDialog: {
        styleOverrides: {
            paper: {
                borderRadius: 16,
                boxShadow: '0px 24px 48px rgba(0, 0, 0, 0.2)',
            },
        },
    },
    // Skeleton overrides
    MuiSkeleton: {
        styleOverrides: {
            root: {
                backgroundColor: "".concat(bomatrustColors.lightGray, "80"),
            },
        },
    },
    // LinearProgress overrides
    MuiLinearProgress: {
        styleOverrides: {
            root: {
                borderRadius: 4,
                height: 6,
            },
        },
    },
    // Divider overrides
    MuiDivider: {
        styleOverrides: {
            root: {
                borderColor: bomatrustColors.lightGray,
            },
        },
    },
};

/**
 * Boma Trust Theme Options
 *
 * Combines palette, typography, and component overrides
 * into a cohesive theme configuration.
 */
var themeOptions = {
    palette: palette,
    typography: typography,
    shape: {
        borderRadius: 8,
    },
    components: components,
};
/**
 * Boma Trust MUI Theme
 *
 * The complete, ready-to-use MUI theme for Boma Trust applications.
 *
 * @example
 * ```tsx
 * import { ThemeProvider } from '@mui/material/styles';
 * import { theme } from '@bomatrust/shared';
 *
 * function App() {
 *   return (
 *     <ThemeProvider theme={theme}>
 *       <YourApp />
 *     </ThemeProvider>
 *   );
 * }
 * ```
 */
var theme = createTheme(themeOptions);

/**
 * Boma Trust Validation Utilities
 *
 * Common validation functions for forms and data.
 */
/**
 * Validate an email address
 *
 * @param email - Email to validate
 * @returns True if valid
 *
 * @example
 * isValidEmail('user@example.com') // true
 * isValidEmail('invalid-email') // false
 */
function isValidEmail(email) {
    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
/**
 * Validate a Kenyan phone number
 *
 * @param phone - Phone number to validate
 * @returns True if valid
 *
 * @example
 * isValidKenyanPhone('0712345678') // true
 * isValidKenyanPhone('+254712345678') // true
 * isValidKenyanPhone('123') // false
 */
function isValidKenyanPhone(phone) {
    // Remove all non-digits except +
    var cleaned = phone.replace(/[^\d+]/g, '');
    // Check various Kenyan formats
    var patterns = [
        /^0[17]\d{8}$/, // 0712345678 or 0112345678
        /^\+254[17]\d{8}$/, // +254712345678
        /^254[17]\d{8}$/, // 254712345678
    ];
    return patterns.some(function (pattern) { return pattern.test(cleaned); });
}
/**
 * Validate password strength
 *
 * @param password - Password to validate
 * @returns Validation result with strength and messages
 *
 * @example
 * validatePassword('weak') // { isValid: false, strength: 'weak', messages: [...] }
 * validatePassword('Strong1!') // { isValid: true, strength: 'strong', messages: [] }
 */
function validatePassword(password) {
    var messages = [];
    var score = 0;
    // Length check
    if (password.length < 8) {
        messages.push('Password must be at least 8 characters');
    }
    else {
        score += 1;
        if (password.length >= 12)
            score += 1;
    }
    // Uppercase check
    if (!/[A-Z]/.test(password)) {
        messages.push('Password must contain at least one uppercase letter');
    }
    else {
        score += 1;
    }
    // Lowercase check
    if (!/[a-z]/.test(password)) {
        messages.push('Password must contain at least one lowercase letter');
    }
    else {
        score += 1;
    }
    // Number check
    if (!/\d/.test(password)) {
        messages.push('Password must contain at least one number');
    }
    else {
        score += 1;
    }
    // Special character check
    if (!/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
        messages.push('Password must contain at least one special character');
    }
    else {
        score += 1;
    }
    var strength = 'weak';
    if (score >= 5)
        strength = 'strong';
    else if (score >= 3)
        strength = 'medium';
    return {
        isValid: messages.length === 0,
        strength: strength,
        messages: messages,
    };
}
/**
 * Validate a Kenyan National ID number
 *
 * @param idNumber - ID number to validate
 * @returns True if valid format
 *
 * @example
 * isValidKenyanId('12345678') // true
 * isValidKenyanId('123') // false
 */
function isValidKenyanId(idNumber) {
    // Kenyan IDs are 7-8 digits
    var cleaned = idNumber.replace(/\D/g, '');
    return cleaned.length >= 7 && cleaned.length <= 8;
}
/**
 * Validate a URL
 *
 * @param url - URL to validate
 * @returns True if valid
 *
 * @example
 * isValidUrl('https://example.com') // true
 * isValidUrl('not-a-url') // false
 */
function isValidUrl(url) {
    try {
        new URL(url);
        return true;
    }
    catch (_a) {
        return false;
    }
}
/**
 * Check if a value is empty (null, undefined, empty string, empty array)
 *
 * @param value - Value to check
 * @returns True if empty
 */
function isEmpty(value) {
    if (value === null || value === undefined)
        return true;
    if (typeof value === 'string')
        return value.trim() === '';
    if (Array.isArray(value))
        return value.length === 0;
    if (typeof value === 'object')
        return Object.keys(value).length === 0;
    return false;
}
/**
 * Validate a price/amount
 *
 * @param amount - Amount to validate
 * @param options - Validation options
 * @returns True if valid
 *
 * @example
 * isValidAmount(1000) // true
 * isValidAmount(-100) // false
 * isValidAmount(100, { min: 1000 }) // false
 */
function isValidAmount(amount, options) {
    if (options === void 0) { options = {}; }
    var _a = options.min, min = _a === void 0 ? 0 : _a, _b = options.max, max = _b === void 0 ? Number.MAX_SAFE_INTEGER : _b;
    return !isNaN(amount) && amount >= min && amount <= max;
}
/**
 * Validate file type
 *
 * @param file - File to validate
 * @param allowedTypes - Array of allowed MIME types or extensions
 * @returns True if valid
 *
 * @example
 * isValidFileType(file, ['image/jpeg', 'image/png']) // true/false
 * isValidFileType(file, ['.pdf', '.doc']) // true/false
 */
function isValidFileType(file, allowedTypes) {
    var _a;
    var fileExtension = ".".concat((_a = file.name.split('.').pop()) === null || _a === void 0 ? void 0 : _a.toLowerCase());
    return allowedTypes.some(function (type) {
        if (type.startsWith('.')) {
            return fileExtension === type.toLowerCase();
        }
        if (type.endsWith('/*')) {
            return file.type.startsWith(type.replace('/*', '/'));
        }
        return file.type === type;
    });
}
/**
 * Validate file size
 *
 * @param file - File to validate
 * @param maxSizeBytes - Maximum size in bytes
 * @returns True if valid
 *
 * @example
 * isValidFileSize(file, 10 * 1024 * 1024) // 10MB max
 */
function isValidFileSize(file, maxSizeBytes) {
    return file.size <= maxSizeBytes;
}

/**
 * Boma Trust Constants
 *
 * Shared constants used across the platform.
 */
/**
 * Property Types
 */
var PROPERTY_TYPES = [
    { value: 'apartment', label: 'Apartment' },
    { value: 'house', label: 'House' },
    { value: 'villa', label: 'Villa' },
    { value: 'townhouse', label: 'Townhouse' },
    { value: 'bungalow', label: 'Bungalow' },
    { value: 'maisonette', label: 'Maisonette' },
    { value: 'land', label: 'Land' },
    { value: 'commercial', label: 'Commercial' },
    { value: 'industrial', label: 'Industrial' },
];
/**
 * User Roles
 */
var USER_ROLES = {
    INVESTOR: 'INVESTOR',
    SELLER: 'SELLER',
    AGENT: 'AGENT',
    ADMIN: 'ADMIN',
};
/**
 * Verification Statuses
 */
var VERIFICATION_STATUSES = {
    VERIFIED: 'verified',
    PENDING: 'pending',
    UNVERIFIED: 'unverified',
    REJECTED: 'rejected',
};
/**
 * Document Types
 */
var DOCUMENT_TYPES = [
    { value: 'title_deed', label: 'Title Deed' },
    { value: 'survey_plan', label: 'Survey Plan' },
    { value: 'land_search', label: 'Land Search Certificate' },
    { value: 'rates_clearance', label: 'Rates Clearance Certificate' },
    { value: 'land_rent_clearance', label: 'Land Rent Clearance' },
    { value: 'consent_to_transfer', label: 'Consent to Transfer' },
    { value: 'valuation_report', label: 'Valuation Report' },
    { value: 'id_copy', label: 'ID Copy' },
    { value: 'kra_pin', label: 'KRA PIN Certificate' },
    { value: 'passport_photo', label: 'Passport Photo' },
    { value: 'other', label: 'Other Document' },
];
/**
 * Kenyan Counties
 */
var KENYAN_COUNTIES = [
    'Baringo',
    'Bomet',
    'Bungoma',
    'Busia',
    'Elgeyo-Marakwet',
    'Embu',
    'Garissa',
    'Homa Bay',
    'Isiolo',
    'Kajiado',
    'Kakamega',
    'Kericho',
    'Kiambu',
    'Kilifi',
    'Kirinyaga',
    'Kisii',
    'Kisumu',
    'Kitui',
    'Kwale',
    'Laikipia',
    'Lamu',
    'Machakos',
    'Makueni',
    'Mandera',
    'Marsabit',
    'Meru',
    'Migori',
    'Mombasa',
    "Murang'a",
    'Nairobi',
    'Nakuru',
    'Nandi',
    'Narok',
    'Nyamira',
    'Nyandarua',
    'Nyeri',
    'Samburu',
    'Siaya',
    'Taita-Taveta',
    'Tana River',
    'Tharaka-Nithi',
    'Trans-Nzoia',
    'Turkana',
    'Uasin Gishu',
    'Vihiga',
    'Wajir',
    'West Pokot',
];
/**
 * Boma Trust Score Ranges
 */
var SCORE_RANGES = {
    EXCELLENT: { min: 90, max: 100, label: 'Excellent', color: '#1B9C6E' },
    GOOD: { min: 75, max: 89, label: 'Good', color: '#4CAF50' },
    FAIR: { min: 60, max: 74, label: 'Fair', color: '#FFC107' },
    CAUTION: { min: 40, max: 59, label: 'Caution', color: '#FF9800' },
    HIGH_RISK: { min: 0, max: 39, label: 'High Risk', color: '#F44336' },
};
/**
 * Get score label and color based on score value
 */
function getScoreInfo(score) {
    if (score >= SCORE_RANGES.EXCELLENT.min)
        return SCORE_RANGES.EXCELLENT;
    if (score >= SCORE_RANGES.GOOD.min)
        return SCORE_RANGES.GOOD;
    if (score >= SCORE_RANGES.FAIR.min)
        return SCORE_RANGES.FAIR;
    if (score >= SCORE_RANGES.CAUTION.min)
        return SCORE_RANGES.CAUTION;
    return SCORE_RANGES.HIGH_RISK;
}
/**
 * Pagination Defaults
 */
var PAGINATION = {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
};
/**
 * File Upload Limits
 */
var FILE_LIMITS = {
    MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
    MAX_IMAGE_SIZE: 5 * 1024 * 1024, // 5MB
    MAX_FILES: 10,
    ALLOWED_IMAGE_TYPES: ['image/jpeg', 'image/png', 'image/webp'],
    ALLOWED_DOCUMENT_TYPES: ['application/pdf', 'image/jpeg', 'image/png'],
};
/**
 * API Endpoints (relative paths)
 */
var API_ENDPOINTS = {
    AUTH: {
        LOGIN: '/auth/login',
        SIGNUP: '/auth/signup',
        LOGOUT: '/auth/logout',
        REFRESH: '/auth/refresh-token',
        ME: '/auth/me',
        FORGOT_PASSWORD: '/auth/forgot-password',
        RESET_PASSWORD: '/auth/reset-password',
        VERIFY_EMAIL: '/auth/verify-email',
        CHANGE_PASSWORD: '/auth/change-password',
    },
    PROPERTIES: {
        LIST: '/properties',
        SEARCH: '/properties/search',
        FEATURED: '/properties/featured',
        FAVORITES: '/properties/favorites',
        MY_LISTINGS: '/properties/my-listings',
        DETAIL: function (id) { return "/properties/".concat(id); },
        FAVORITE: function (id) { return "/properties/".concat(id, "/favorite"); },
    },
    DOCUMENTS: {
        UPLOAD: '/documents/upload',
        LIST: '/documents',
        DETAIL: function (id) { return "/documents/".concat(id); },
    },
};
/**
 * Local Storage Keys
 */
var STORAGE_KEYS = {
    TOKEN: 'token',
    REFRESH_TOKEN: 'refreshToken',
    USER: 'user',
    THEME: 'theme',
    LANGUAGE: 'language',
    CURRENCY: 'currency',
};
/**
 * Currency Exchange Rate (KES to USD)
 * Note: This should be fetched from an API in production
 */
var DEFAULT_EXCHANGE_RATE = 130;
/**
 * Date Format Patterns
 */
var DATE_FORMATS = {
    SHORT: 'MMM d',
    MEDIUM: 'MMM d, yyyy',
    LONG: 'MMMM d, yyyy',
    ISO: 'yyyy-MM-dd',
    DATETIME: 'MMM d, yyyy h:mm a',
};

/**
 * @bomatrust/shared - Shared Component Library
 *
 * This package provides reusable components, hooks, services, utilities,
 * and theme configuration for all Boma Trust web applications.
 */
// ============================================================================
// Brand Configuration (SINGLE SOURCE OF TRUTH)
// ============================================================================
// ============================================================================
// Package Info
// ============================================================================
var version = '0.1.0';

export { API_ENDPOINTS, AuthContext, BRAND, Button, CURRENCY_SYMBOLS, Card, ClickableCard, DATE_FORMATS, DEFAULT_EXCHANGE_RATE, DOCUMENT_TYPES, EmptyState, FILE_LIMITS, FileUpload, FormSection, Input, KENYAN_COUNTIES, ListSkeleton, NotificationProvider, PAGINATION, PROPERTY_TYPES, PageHeader, PageSkeleton, PriceDisplay, PropertyCard, PropertyCardSkeleton, SCORE_RANGES, STORAGE_KEYS, SectionCard, SelectField, TableSkeleton, TextField, TrustScoreDisplay, USER_ROLES, VERIFICATION_STATUSES, VerificationBadge, api, authService, bomatrustColors, createApiClient, createAuthService, createPropertyService, fontFamily, fontWeights, formatCompactNumber, formatCurrency, formatDate, formatFileSize$1 as formatFileSize, formatName, formatNumber, formatPercentage, formatPhoneNumber, formatRelativeTime, getScoreInfo, hasAnyRole, hasRole, isEmpty, isValidAmount, isValidEmail, isValidFileSize, isValidFileType, isValidKenyanId, isValidKenyanPhone, isValidUrl, palette, propertyService, theme, components as themeComponents, themeOptions, truncateText, typography, useAsync, useAuth, useDebounce, useDebouncedCallback, useIsDesktop, useIsLargeDesktop, useIsMobile, useIsTablet, useLocalStorage, useMediaQuery, useNotification, usePagination, usePrefersDarkMode, usePrefersReducedMotion, validatePassword, version };
//# sourceMappingURL=index.js.map
